import * as React from "react";
import { changePasswordSchema } from "@njoy/common";
import { NormalizedErrorMap, ForgotPasswordChangeMutationMutationVariables } from "@njoy/controller";
import { Form as AntForm } from "antd";
import { withFormik, FormikProps, Field, Form } from "formik";
import NewButton from "../../../../components/uiMerge/newButton"
import { InputField } from "../../../shared/InputField";
import { BackButton } from "../../../../components/uiMerge/backButton";
import { ToastContainer } from "react-toastify";
import ToastMessage from "../../../../hooks/useToast";
import { extractError } from "../../../../utils/extractError";
import "react-toastify/dist/ReactToastify.css";
const FormItem = AntForm.Item;

interface FormValues {
  newPassword: string;
  confirmNewPassword: string;
}

export interface Props {
  onFinish: () => void;
  token: string;
  submit: (
    values: ForgotPasswordChangeMutationMutationVariables
  ) => Promise<NormalizedErrorMap | null>;
  loading?: boolean;
  error?: Error;
}

class C extends React.PureComponent<FormikProps<FormValues> & Props> {
  render() {
    return (
        <>
       <ToastContainer />
      <div className='flex flex-col items-center min-h-screen w-full px-[1rem]'>
        <div className='flex flex-row justify-between items-center flex-nowrap w-full mt-12 '>
          <BackButton onClick={() => window.history.back()} />
          <p className='text-2xl text-center text-white mx-auto'>
            Change Password
          </p>
        </div>

        <div className="w-full flex flex-col mt-12 flex-1">
          <Form className="flex flex-col h-full flex-1">
            <label className="text-white p-1 opacity-[80%]" htmlFor="password"> New Password</label>
            <Field
              name="newPassword"
              type="password"
              placeholder="New Password"
              component={InputField}
            />
            
            <label className="text-white p-1 opacity-[80%]" htmlFor="confirmPassword"> Confirm Password</label>
            <Field
              name="confirmNewPassword"
              type="password"
              placeholder="Confirm New Password"
              component={InputField}
            />

            <div className="mt-auto">
              <FormItem>
                <NewButton
                fullWidth
                loading={this.props.isSubmitting}
                variant="primary"
                type="submit"
                className="login-form-button">
                  Change Password
                </NewButton>
              </FormItem>
            </div>
          </Form>
        </div>
      </div>
      </>
    );
  }
}

export const ChangePasswordView = withFormik<Props, FormValues>({
  validationSchema: changePasswordSchema,
  mapPropsToValues: () => ({ newPassword: "", confirmNewPassword: "" }),
  handleSubmit: async ({ newPassword, confirmNewPassword }, { props, setErrors, setSubmitting }) => {
    try {
      setSubmitting(true);
      const serverErrors = await props.submit({ newPassword, confirmNewPassword, key: props.token });

      if (serverErrors) {
        setSubmitting(false);
        ToastMessage("error", extractError(serverErrors));
        setErrors(serverErrors);
        return;
      }

      setSubmitting(false);
      props.onFinish();
    } catch (error: any) {
      setSubmitting(false);
      ToastMessage("error", (error as Error)?.message);
    }
  }
})(C as any);
